import { createContext, useContext } from "react";

/** A payment popup owns interaction until its success/close/error callback. */
export const ExternalPaymentContext = createContext<() => () => void>(
  () => () => {}
);
export const useExternalPayment = () => useContext(ExternalPaymentContext);
